import { ImageType, FileType } from "../types/baseTypes";

export const getImageType = ({
  width,
  images,
}: {
  width: number;
  images: {
    image_fullhd: ImageType | false;
    image_desktop: ImageType;
    image_tablet?: ImageType | false;
    image_mobile?: ImageType | false;
  };
}): ImageType => {
  if (width >= 1048 && images.image_fullhd) {
    return images.image_fullhd;
  } else if (width >= 1024 && images.image_desktop) {
    return images.image_desktop;
  } else if (width >= 768 && (images.image_tablet || images.image_desktop)) {
    return images.image_tablet || images.image_desktop;
  } else if (
    width > 0 &&
    width < 768 &&
    (images.image_mobile || images.image_desktop)
  ) {
    return images.image_mobile || images.image_desktop;
  } else {
    return images.image_desktop;
  }
};

export const getVideoType = ({
  width,
  videos,
}: {
  width: number;
  videos: {
    video: FileType | false;
    video_tablet: FileType | false;
    video_mobile: FileType | false;
  };
}): { video: FileType | false } => {
  if (width >= 1024 && videos.video) {
    return { video: videos.video };
  } else if (width >= 768 && videos.video_tablet) {
    return { video: videos.video_tablet };
  } else if (width > 0 && width < 768 && videos.video_mobile) {
    return { video: videos.video_mobile };
  } else {
    return { video: videos.video };
  }
};
